import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type TenantSmtpConnectionFragment = { __typename?: 'TenantSmtpConnectionData', host: string, port: number, username: string, fromMode: Types.SmtpFromMode, status: Types.SmtpConnectionStatus, lastVerifiedAt?: Types.TDateISO | null, lastError?: string | null, updatedAt: Types.TDateISO, addresses: Array<{ __typename?: 'SmtpSenderAddressData', email: string, displayName: string, adminOnly: boolean }> };

export type GetTenantSmtpConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantSmtpConnectionQuery = { __typename?: 'Query', tenantSmtpConnection?: { __typename?: 'TenantSmtpConnectionData', host: string, port: number, username: string, fromMode: Types.SmtpFromMode, status: Types.SmtpConnectionStatus, lastVerifiedAt?: Types.TDateISO | null, lastError?: string | null, updatedAt: Types.TDateISO, addresses: Array<{ __typename?: 'SmtpSenderAddressData', email: string, displayName: string, adminOnly: boolean }> } | null };

export const TenantSmtpConnectionFragmentDoc = new TypedDocumentString(`
    fragment TenantSmtpConnection on TenantSmtpConnectionData {
  host
  port
  username
  fromMode
  addresses {
    email
    displayName
    adminOnly
  }
  status
  lastVerifiedAt
  lastError
  updatedAt
}
    `, {"fragmentName":"TenantSmtpConnection"});
export const GetTenantSmtpConnectionDocument = new TypedDocumentString(`
    query GetTenantSmtpConnection {
  tenantSmtpConnection {
    ...TenantSmtpConnection
  }
}
    fragment TenantSmtpConnection on TenantSmtpConnectionData {
  host
  port
  username
  fromMode
  addresses {
    email
    displayName
    adminOnly
  }
  status
  lastVerifiedAt
  lastError
  updatedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantSmtpConnection: build.query<GetTenantSmtpConnectionQuery, GetTenantSmtpConnectionQueryVariables | void>({
      query: (variables) => ({ document: GetTenantSmtpConnectionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantSmtpConnectionQuery, useLazyGetTenantSmtpConnectionQuery } = injectedRtkApi;
